import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { StorageService } from '../../../shared/security/StorageService';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../shared/spinner/spinner.service';
import { OfficeSelectableListModel } from '../../../model/officeSelectableListModel';
import { TransferEmployerCloseOfficeService } from '../transfer-employer-close-office.service';
import { SearchEmployeesToManageRequestModel } from '../../../model/searchEmployeesToManageRequestModel';
import { MessageModel, ContentPageModel } from '../../../model/models';
import * as $ from 'jquery';
import { SearchEmployeesToManageResponseModel } from '../../../model/searchEmployeesToManageResponseModel';
import { Subscription } from 'rxjs';
import { SelectEmployeesToManageRequestModel } from '../../../model/selectEmployeesToManageRequestModel';
import { EmployeeSelectableListModel } from '../../../model/employeeSelectableListModel';


@Component({
  selector: 'app-search-employees',
  templateUrl: './search-employees.component.html',
  styleUrls: ['./search-employees.component.css']
})
export class SearchEmployeesComponent implements OnInit , OnDestroy{

  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel;
  selectedAll: any;

  userMessages: Array<MessageModel> = [];
  title: string = "";
  stepMessageSubscription : Subscription;
  notifySelectEmployeesRequestModelSubscription = new Subscription();

  stepMessageDisplay : boolean = true;

  officesList: Array<OfficeSelectableListModel> = [];
  searchEmployeesRequestModel: SearchEmployeesToManageRequestModel = new SearchEmployeesToManageRequestModel();
  selectEmployeesModel: SelectEmployeesToManageRequestModel = new SelectEmployeesToManageRequestModel();
  EmployeeList: Array<EmployeeSelectableListModel> = [];

  constructor(private startFunctionService: StartFunctionService, 
    private transferEmployerCloseOfficeService: TransferEmployerCloseOfficeService,
    private storage: StorageService, private router: Router,
    private spinner: SpinnerService,
    private currentPageWatcher: CurrentPageWatcherService) {
    this.startFunction = this.storage.getStartFunctionData();
    if (this.startFunction != null && this.startFunction != undefined && this.startFunction.Workflow != null) {
      this.workflow = this.startFunction.Workflow;
      this.title = this.workflow.WorkflowDisplayName;

    }
    this.transferEmployerCloseOfficeService.getNotifyEmployeeSelectableList().subscribe(empListData=>{
      this.EmployeeList = empListData;
    });

    this.notifySelectEmployeesRequestModelSubscription = this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().subscribe(selectEmplReqData => {
      this.selectEmployeesModel = selectEmplReqData;
    });
  }

  ngOnInit() {

    this.currentPageWatcher.pageChanged().emit(this.title);

    this.transferEmployerCloseOfficeService.getSelectableOffices(this.workflow.WorkflowID).subscribe(
      response => {

        response.forEach(el => {
          el.selected = false;
          this.officesList.push(el);

        })

        console.log("List of Offices", this.officesList);
      });
  }
  ngOnDestroy(): void {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearStepMessage();
      
    }
  selectAll() {
    for (var i = 0; i < this.officesList.length; i++) {
      if(this.officesList[i].IsSelectable){
        this.officesList[i].selected = this.selectedAll;
      }
    }
  }
  checkIfAllSelected() {
    this.selectedAll = this.officesList.every(function (item: any) {
      return item.selected == true;
    })
  }

  onContinue() {
    this.currentPageWatcher.sendUserMessages(null);
    this.searchEmployeesRequestModel.EntityID = this.officesList.filter(element => element.selected).map(element => element.EntityID);
    this.searchEmployeesRequestModel.WorkflowID = this.startFunction.Workflow.WorkflowID;
    this.searchEmployeesRequestModel.CurrentStepIndex = this.startFunction.Workflow.CurrentStepIndex;
    //
    this.transferEmployerCloseOfficeService.searchEmployeesByCriteria(this.searchEmployeesRequestModel).subscribe((response: SearchEmployeesToManageResponseModel) => {
      console.log("userMessage on searchEmployeesByCriteria ", response.UserMessages);
      response.UserMessages.forEach(el => {
        this.userMessages.push(el);
      });
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      if (response.Summary == 0 ) {
        this.router.navigate(['/selectEmployees']).then(() => {
          this.startFunctionService.getNotifyStepInProgress().emit(true);
          this.transferEmployerCloseOfficeService.getNotifySearchEmployeesToManageResponseModel().emit(response);
          this.transferEmployerCloseOfficeService.getNotifySelectEmployeesRequestModel().emit(this.selectEmployeesModel);

        });
        this.userMessages = [];
      }
      if (response.Summary == 1) {
        $("html, body").animate({ scrollTop: 0 }, "slow");
        this.userMessages = [];
      }

      if (response.Summary == 2) {
        this.router.navigate(["/home"]);
        this.userMessages = [];
      }
    }
    )
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.currentPageWatcher.sendUserMessages(null);
    this.startFunctionService.getNotifyStepInProgress().emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/broker/transfer-employer-close-office/search-employees/search-employees.component.ts